import React from 'react';
import { useIntl } from 'umi';
import { Bubble } from 'tea-component';

import './index.scss';

import AppAnnieIcon from '@intelligence/assets/svg/dataSource/app-annie.svg';
import SensorTowerIcon from '@intelligence/assets/svg/dataSource/sensor-tower.svg';
import DataBrainIcon from '@intelligence/assets/svg/dataSource/databarin-bg.svg';

interface IGenreHeaderProps {
  genreSource?: 'annie' | 'sensortower' | 'iegg' | 'weixin' | '';
}

const GenreHeader: React.FC<IGenreHeaderProps> = (props) => {
  const { genreSource = '' } = props;

  const { formatMessage } = useIntl();

  const contentMapping: IRecord<React.ReactElement> = {
    annie: (
      <Bubble content={formatMessage({ id: 'dbi_info_dataai_genre' })} dark>
        <img className="header-icon" src={AppAnnieIcon} alt="" />
        <span className="dbi-cursor-pointer">{formatMessage({ id: 'dbi_top_dataai_genre' })}</span>
      </Bubble>
    ),
    sensortower: (
      <Bubble content={formatMessage({ id: 'dbi_info_sensortower_genre' })} dark>
        <img className="header-icon" src={SensorTowerIcon} alt="" />
        <span className="dbi-cursor-pointer">{formatMessage({ id: 'dbi_top_sensortower_genre' })}</span>
      </Bubble>
    ),
    iegg: (
      <Bubble content={formatMessage({ id: 'dbi_info_iegg_genre' })} dark>
        <img className="header-icon header-icon-iegg" src={DataBrainIcon} alt="" />
        <span className="dbi-cursor-pointer">{formatMessage({ id: 'dbi_top_iegg_genre' })}</span>
      </Bubble>
    ),
  };

  return (
    <div className="general_table_genre-header">
      {contentMapping[genreSource] || (
        <span className="dbi-cursor-pointer">{formatMessage({ id: 'dbi_top_genre' })}</span>
      )}
    </div>
  );
};

export default GenreHeader;
